import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientinstructionApi } from '../api/patientinstruction.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientinstructionData, PatientinstructionMst } from '../../../interfaces/masters/patientinstruction';

//import { PatientinstructionMst,PatientinstructionData } from '../../../interfaces/masters/patientinstruction';

@Injectable()
export class PatientinstructionService extends PatientinstructionData {

  constructor(private api: PatientinstructionApi) {
    super();    
  }
  list(url: string): Observable<PatientinstructionMst[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientinstructionMst>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientinstructionMst): Observable<PatientinstructionMst> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientinstructionMst): Observable<PatientinstructionMst> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
